import { ExtendedRawUserProfile } from 'hooks/useIdentifyAnalytics/types';
import { getPianoCookieClient } from 'utils/getPianoCookieClient';
import { getSubscriptionName } from 'utils/getSubscriptionName';

import type { FooterUserData, HeaderUserData } from './types';
import {
  legacyHeaderProfileMapFactory,
  legacyFooterProfileMapFactory
} from './legacyProfileMapFactory';

/**
 * @deprecated Use `getUserData` instead.
 */
export const legacyGetHeaderUserData = (
  RIVTProfile: Nullable<ExtendedRawUserProfile>
): HeaderUserData => {
  const pianoUser = getPianoCookieClient();

  if (!pianoUser || !RIVTProfile) {
    return null;
  }

  const profileMap = legacyHeaderProfileMapFactory(RIVTProfile);
  const emailStatus = pianoUser.email_verified ? 'verified' : 'unverified';
  const membership = getSubscriptionName(pianoUser.roles);

  return {
    actingProfileID: pianoUser.uuid,
    profileMap,
    membership,
    emailStatus
  };
};

/**
 * @deprecated Use `getUserData` instead.
 */
export const legacyGetFooterUserData = (
  RIVTProfile: Nullable<ExtendedRawUserProfile>
): FooterUserData => {
  const pianoUser = getPianoCookieClient();

  if (!pianoUser || !RIVTProfile) {
    return null;
  }

  const profileMap = legacyFooterProfileMapFactory(RIVTProfile, pianoUser);

  return {
    actingProfileID: pianoUser.uuid,
    profileMap
  };
};
